
 var swiper = new Swiper(".slide-thumbnail", {
  loop: false,
  slidesPerView: 5,
  direction: "vertical",
});
var swiper2 = new Swiper(".slide-contnet", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

